import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueI18n from 'vue-i18n'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import { judge } from "@/js/judge.js";
import dlUrl from './js/urlConfig.js'
import Vconsole from 'vconsole'
import axios from 'axios'
import 'jquery'
Vue.prototype.dlUrl = dlUrl;
window.console.log(dlUrl)
Vue.config.productionTip = false
Vue.use(ElementUI);
Vue.use(VueI18n)
Vue.prototype.$axios = axios

const i18n = new VueI18n({
    locale: dlUrl.lang,
    messages: {
        'zh': require('./js/lang/zh.js'),
        'en': require('./js/lang/en.js')
    }
})

// 测试环境显示console控制台
if (dlUrl.appId == 1) {
    let vConsole = new Vconsole();
    Vue.use(vConsole)
}

// 控制路由跳转
router.beforeEach((to, from, next) => {
    // 优化跳转
    if (judge()) {
        if (to.path == '/') {
            next();
        } else {
            next('/');
        }
    } else {
        if (to.path == '/mobile') {
            next();
        } else {
            next('/mobile');
        }
    }
});

new Vue({
    router,
    i18n,
    render: h => h(App),
}).$mount('#app')
